 (function () { 
window.sfTriggerKlaviyoBis = function () {
  var formId = 'Wwqdaa';
  var attempts = 0;
  var maxAttempts = 30;

  function openForm() {
    window._klOnsite = window._klOnsite || [];

    if (
      window._klOnsite &&
      typeof window._klOnsite.openForm === 'function'
    ) {
      window._klOnsite.openForm(formId);
      return true;
    }

    window._klOnsite.push(['openForm', formId]);
    return true;
  }

  function tryOpen() {
    if (window._klOnsite) {
      openForm();
      return;
    }

    attempts += 1;

    if (attempts < maxAttempts) {
      setTimeout(tryOpen, 250);
      return;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  tryOpen();
};


  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function getPdpConfigs() {
    return Array.from(document.querySelectorAll('[data-pdp-config]'))
      .map((script) => {
        try {
          return JSON.parse(script.textContent || '{}');
        } catch (e) {
          return null;
        }
      })
      .filter(Boolean);
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/"/g, '\\"');
  }

  function canon(v) {
    return String(v == null ? '' : v)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '');
  }

  onReady(function () {
    getPdpConfigs().forEach(initCustomProductSection);
    initAccordionEmbedVideos();
    initCountdowns();
  });

  document.addEventListener('shopify:section:load', function () {
    getPdpConfigs().forEach(initCustomProductSection);
  });

  function initCustomProductSection(config) {
    const root = document.getElementById(config.rootId);
    if (!root || root.dataset.pdpInitialized === 'true') return;

    root.dataset.pdpInitialized = 'true';

initMediaSlider(root, config);

if (config.enableFreePair) {
  initOldBogoPairs(root, config);
} else {
  initVariantLogic(root, config);
  initPriceObserver(root, config);
  initQuantity(root, config);
}

initCustomAccordions(root, config);
initSelloutDropdowns(root);
initAppliedDiscountNote(root, config);
  }

  function initVariantLogic(root, config) {
    const sectionId = config.sectionId;
    const IDX = config.indexes || {};
    const HAS = {
      size: IDX.size !== null && IDX.size !== undefined,
      band: IDX.band !== null && IDX.band !== undefined,
      color: IDX.color !== null && IDX.color !== undefined
    };

    const VARIANTS = Array.isArray(config.variants) ? config.variants : [];
    const HIDDEN_COLOR_VALUES = Array.isArray(config.hiddenColorValues) ? config.hiddenColorValues : [];

    const q = (s, r = root) => r.querySelector(s);
    const qa = (s, r = root) => Array.from(r.querySelectorAll(s));

    function groupName(idx) {
      return `option-${idx}-${sectionId}`;
    }

    function optionAt(variant, idx) {
      return !variant || idx === null || idx === undefined
        ? null
        : Array.isArray(variant.options)
          ? variant.options[idx]
          : null;
    }

    function readOption(idx) {
      return idx === null || idx === undefined
        ? null
        : q(`input[name="${cssEscape(groupName(idx))}"]:checked`)?.value || null;
    }

    function getSelectedOptions() {
      const selected = new Array(config.optionCount || 0).fill(null);
      for (let i = 0; i < selected.length; i++) {
        selected[i] = readOption(i);
      }
      return selected;
    }

    function readSelection() {
      const options = getSelectedOptions();
      return {
        size: HAS.size ? options[IDX.size] : null,
        band: HAS.band ? options[IDX.band] : null,
        color: HAS.color ? options[IDX.color] : null,
        options
      };
    }

    function stockQty(variant) {
      const qty = Number(variant?.inventory_quantity);
      return Number.isFinite(qty) ? qty : 0;
    }

    function hasInventoryTracking(variant) {
      return !!String(variant?.inventory_management || '').trim();
    }

    function canContinueSelling(variant) {
      return String(variant?.inventory_policy || '').toLowerCase() === 'continue';
    }

    function isHiddenColorValue(value) {
      return HAS.color && HIDDEN_COLOR_VALUES.some((hiddenValue) => canon(hiddenValue) === canon(value));
    }

    function isVisibleVariant(variant) {
      return !variant ? false : (!HAS.color || !isHiddenColorValue(optionAt(variant, IDX.color)));
    }

    function isSellable(variant) {
      if (!variant) return false;
      if (variant.available === true) return true;
      if (!hasInventoryTracking(variant)) return true;
      if (canContinueSelling(variant)) return true;
      return stockQty(variant) > 0;
    }

    function matchesOptions(variant, options) {
      if (!variant) return false;

      for (let idx = 0; idx < options.length; idx++) {
        if (options[idx] && canon(optionAt(variant, idx)) !== canon(options[idx])) return false;
      }

      return true;
    }

    function findVariantByOptions(options, requireSellable = false) {
      return VARIANTS.find((variant) => {
        return isVisibleVariant(variant) &&
          (!requireSellable || isSellable(variant)) &&
          matchesOptions(variant, options);
      }) || null;
    }

    function getExactSelectedVariant() {
      return findVariantByOptions(getSelectedOptions(), false);
    }

    function updateVariantURL(variantId) {
      if (!variantId) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({ path: url.toString() }, '', url.toString());
    }

    function updateAvailabilityUI(variant) {
      const el = q('.product-info .text-success, .product-info .text-danger');
      if (!el) return;

      if (isSellable(variant)) {
        const tracker = String(variant?.inventory_management || '').toLowerCase();
        const qty = stockQty(variant);
        const qtyText = tracker === 'shopify' && qty > 0 ? ` (${qty} available)` : '';
        el.className = 'text-success mb-2';
        el.innerHTML = `<i class="bi bi-check-circle-fill"></i> In Stock${qtyText}`;
      } else {
        el.className = 'text-danger mb-2';
        el.innerHTML = '<i class="bi bi-x-circle-fill"></i> Out of Stock';
      }
    }

    function updateAddToCartButtonUI(variant) {
      const btn = q('.add-to-cart-btn');
      if (!btn) return;

      const txt = btn.querySelector('.btn-text');
      const sellable = isSellable(variant);

      btn.disabled = !sellable;
      if (txt) txt.innerHTML = sellable ? '<i class="bi bi-cart-plus"></i> ADD TO BAG' : 'Sold Out';
    }

    function commitVariant(variant) {
      const idInput = q('input.product-variant-id[name="id"]');
      const qty = parseInt(q('#productQuantity')?.value, 10) || 1;

      if (variant && idInput) {
        idInput.value = variant.id;
        idInput.removeAttribute('disabled');
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (idInput) {
        idInput.setAttribute('disabled', 'disabled');
      }

      if (variant) {
        updateVariantURL(variant.id);
        if (typeof window.updatePrice === 'function') {
          window.updatePrice(root, variant, variant.price * qty, qty);
        }
      }

      updateAvailabilityUI(variant);
      updateAddToCartButtonUI(variant);

      if (typeof window.__PDP_QTY_SYNC_TO_VARIANT__ === 'function') {
        window.__PDP_QTY_SYNC_TO_VARIANT__(variant);
      }
    }

    function applyColorUI() {
      if (!HAS.color) return;

      const inputs = qa(`input[name="${cssEscape(groupName(IDX.color))}"]`);
      const checked = q(`input[name="${cssEscape(groupName(IDX.color))}"]:checked`);
      const selectedColorTarget = q('.product-option.product-option-other [data-selected-color]');

      inputs.forEach((input) => {
        const lbl = q(`label.color-swatch[for="${cssEscape(input.id)}"]`);
        if (lbl) lbl.classList.toggle('selected', checked === input);
      });

      if (selectedColorTarget) {
        selectedColorTarget.textContent = checked && checked.value ? `: ${checked.value}` : '';
      }

      if (
        checked &&
        window.__PDP_MEDIA_SLIDER__ &&
        typeof window.__PDP_MEDIA_SLIDER__.goToColor === 'function'
      ) {
        window.__PDP_MEDIA_SLIDER__.goToColor(checked.value);
      }
    }

    function sizeValueIsSellable(sizeValue, selection) {
      if (!HAS.size) return false;

      const options = Array.isArray(selection?.options) ? selection.options.slice() : getSelectedOptions();
      options[IDX.size] = sizeValue;

      return !!findVariantByOptions(options, true);
    }

    function ensureVisibleColorSelection() {
      if (!HAS.color) return;

      const inputs = qa(`input[name="${cssEscape(groupName(IDX.color))}"]`);
      if (!inputs.length) return;

      const checked = inputs.find((input) => input.checked);
      if (!checked) inputs[0].checked = true;
    }

    function updateSizeAvailability() {
      if (!HAS.size) return;

      const selection = readSelection();
      const sizeInputs = qa(`input[name="${cssEscape(groupName(IDX.size))}"]`);

      sizeInputs.forEach((input) => {
        input.disabled = !sizeValueIsSellable(input.value, selection);
      });

      const checked = sizeInputs.find((input) => input.checked) || null;

      if (!checked || checked.disabled) {
        const firstEnabled = sizeInputs.find((input) => !input.disabled);
        if (firstEnabled) firstEnabled.checked = true;
      }
    }

    function syncAll() {
      ensureVisibleColorSelection();
      updateSizeAvailability();

      const variant = getExactSelectedVariant();

      commitVariant(variant);
      applyColorUI();
    }

    function initColorSwatches() {
      if (!HAS.color) return;

      const inputs = qa(`input[name="${cssEscape(groupName(IDX.color))}"]`);

      inputs.forEach((input) => {
        const lbl = q(`label.color-swatch[for="${cssEscape(input.id)}"]`);
        if (!lbl) return;

        lbl.addEventListener('pointerdown', function (e) {
          e.preventDefault();

          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }

          syncAll();
        }, { passive: false });
      });
    }

    window.__PDP_CANON = canon;
    window.__PDP_VARIANTS = VARIANTS;
    window.__PDP_IS_SELLABLE = isSellable;
    window.findSelectedVariant = getExactSelectedVariant;
    window.__PDP_SYNC_ALL = syncAll;

    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches('.variant-selector')) syncAll();
    }, true);

    initColorSwatches();
    syncAll();

    const initialVariant = getExactSelectedVariant();
    if (initialVariant) updateVariantURL(initialVariant.id);
  }

function initOldBogoPairs(root, config) {
  if (!root || root.dataset.oldBogoInitialized === 'true') return;
  root.dataset.oldBogoInitialized = 'true';

  const IDX = config.indexes || {};
  const colorIndex = Number(IDX.color);
  const sizeIndex = Number(IDX.size);
  const bandIndex = Number(IDX.band);
    const FREE_IDX = config.freePairIndexes || {};
  const freeColorIndex = FREE_IDX.color === null || FREE_IDX.color === undefined ? null : Number(FREE_IDX.color);
  const freeSizeIndex = FREE_IDX.size === null || FREE_IDX.size === undefined ? null : Number(FREE_IDX.size);
  const freeBandIndex = FREE_IDX.band === null || FREE_IDX.band === undefined ? null : Number(FREE_IDX.band);

  if (!Number.isFinite(colorIndex) || !Number.isFinite(sizeIndex) || !Number.isFinite(bandIndex)) return;

  const paidVariants = Array.isArray(config.variants) ? config.variants : [];
  const freeVariants = Array.isArray(config.freePairVariants) ? config.freePairVariants : [];
  const pair2Variants = freeVariants.length ? freeVariants : paidVariants;
  const usingExternalFreePairProduct = freeVariants.length > 0;

  const wizard = root.querySelector('[data-old-bogo-wizard]');
  const form = root.querySelector('form[data-type="add-to-cart-form"]');
  const atcBtn = root.querySelector('[data-old-bogo-atc]');
  const atcText = root.querySelector('[data-old-bogo-atc-text]');
  const spinner = root.querySelector('[data-old-bogo-spinner]');
  const variantIdInput = root.querySelector('[data-old-bogo-variant-id]');
  const pair1PropInput = root.querySelector('[data-old-bogo-pair1]');
  const pair2PropInput = root.querySelector('[data-old-bogo-pair2]');

  if (!wizard || !form || !atcBtn) return;

  let activeStep = 1;
  let hasVisitedStep2 = false;
  let isSubmittingBundle = false;

  const stepCards = Array.from(root.querySelectorAll('[data-old-bogo-card]'));
  const stepPanels = Array.from(root.querySelectorAll('[data-old-bogo-panel]'));
  const stepLabel = root.querySelector('[data-old-bogo-step-label]');
  const bandMirror = root.querySelector('[data-old-bogo-band-mirror]');

  function optionAt(variant, index) {
    return variant && Array.isArray(variant.options) ? variant.options[index] : '';
  }

  function checked(selector) {
    return root.querySelector(selector + ':checked');
  }

  function getPairValue(pair, kind) {
    const input = checked('[data-old-bogo-pair="' + pair + '"][data-old-bogo-kind="' + kind + '"]');
    return input ? input.value : '';
  }

  function getBandValue() {
    const input = checked('[data-old-bogo-kind="band"]');
    return input ? input.value : '';
  }

  function sameOption(a, b) {
    return canon(a) === canon(b);
  }

  function findPaidVariant(list, color, size, band) {
    return list.find((variant) => {
      return sameOption(optionAt(variant, colorIndex), color) &&
        sameOption(optionAt(variant, sizeIndex), size) &&
        sameOption(optionAt(variant, bandIndex), band);
    }) || null;
  }

  function findFreeVariant(list, color, size, band) {
    if (!usingExternalFreePairProduct) {
      return findPaidVariant(list, color, size, band);
    }

    return list.find((variant) => {
      const colorOk = freeColorIndex === null || Number.isNaN(freeColorIndex)
        ? true
        : sameOption(optionAt(variant, freeColorIndex), color);

      const sizeOk = freeSizeIndex === null || Number.isNaN(freeSizeIndex)
        ? true
        : sameOption(optionAt(variant, freeSizeIndex), size);

      const bandOk = freeBandIndex === null || Number.isNaN(freeBandIndex)
        ? true
        : sameOption(optionAt(variant, freeBandIndex), band);

      return colorOk && sizeOk && bandOk;
    }) || null;
  }

  function isSellable(variant) {
    if (!variant) return false;
    if (variant.available === true) return true;

    const management = String(variant.inventory_management || '').trim();
    const policy = String(variant.inventory_policy || '').toLowerCase();
    const qty = Number(variant.inventory_quantity || 0);

    if (!management) return true;
    if (policy === 'continue') return true;

    return qty > 0;
  }

  function formatPairText(color, size, band) {
    return [color, size, band].filter(Boolean).join(', ');
  }

  function getBundleSelections() {
    const pair1Color = getPairValue(1, 'color');
    const pair1Size = getPairValue(1, 'size');
    const band = getBandValue();

    const pair2Color = getPairValue(2, 'color') || pair1Color;
    const pair2Size = getPairValue(2, 'size') || pair1Size;

    const pair1Variant = findPaidVariant(paidVariants, pair1Color, pair1Size, band);
    const pair2Variant = findFreeVariant(pair2Variants, pair2Color, pair2Size, band);

    return {
      pair1Color,
      pair1Size,
      pair2Color,
      pair2Size,
      band,
      pair1Variant,
      pair2Variant,
      pair1Text: formatPairText(pair1Color, pair1Size, band),
      pair2Text: formatPairText(pair2Color, pair2Size, band)
    };
  }

  function canGoToPair2(bundle) {
    return !!(bundle && bundle.pair1Variant && isSellable(bundle.pair1Variant));
  }

  function isPair2Invalid(bundle) {
    return !!(
      hasVisitedStep2 &&
      bundle &&
      bundle.pair2Color &&
      bundle.pair2Size &&
      bundle.band &&
      !isSellable(bundle.pair2Variant)
    );
  }

    function markPair2InvalidOnLoad(bundle) {
    if (
      !hasVisitedStep2 &&
      bundle &&
      bundle.pair1Variant &&
      isSellable(bundle.pair1Variant) &&
      bundle.pair2Color &&
      bundle.pair2Size &&
      bundle.band &&
      !isSellable(bundle.pair2Variant)
    ) {
      hasVisitedStep2 = true;
    }
  }

  function setSelectedLabels() {
    root.querySelectorAll('.old-bogo-input').forEach((input) => {
      const label = input.id ? root.querySelector('label[for="' + input.id + '"]') : null;
      if (!label) return;

      if (input.dataset.oldBogoKind === 'color') {
        label.classList.toggle('selected', input.checked);
      }
    });
  }

  function updateSizeAvailabilityForPair(pair, list, color, band) {
    root.querySelectorAll('[data-old-bogo-pair="' + pair + '"][data-old-bogo-kind="size"]').forEach((input) => {
           const variant = pair === 2
        ? findFreeVariant(list, color, input.value, band)
        : findPaidVariant(list, color, input.value, band);
      const unavailable = !isSellable(variant);
      const label = input.id ? root.querySelector('label[for="' + input.id + '"]') : null;

      input.dataset.oldBogoUnavailable = unavailable ? 'true' : 'false';

      if (label) {
        label.dataset.oldBogoUnavailable = unavailable ? 'true' : 'false';
      }
    });
  }

  function updateSummary(bundle) {
    const p1 = root.querySelector('[data-old-bogo-pair-color-text="1"]');
    const p2 = root.querySelector('[data-old-bogo-pair-color-text="2"]');

    if (p1) p1.textContent = bundle.pair1Color || '';
    if (p2) p2.textContent = bundle.pair2Color || '';

    const img1 = root.querySelector('[data-old-bogo-summary-image="1"]');
    const img2 = root.querySelector('[data-old-bogo-summary-image="2"]');

    if (img1 && bundle.pair1Variant) {
      const src1 =
        bundle.pair1Variant.featured_image && bundle.pair1Variant.featured_image.src
          ? bundle.pair1Variant.featured_image.src
          : bundle.pair1Variant.image;

      if (src1) img1.src = src1;
    }

    if (img2 && bundle.pair2Variant) {
      const src2 =
        bundle.pair2Variant.featured_image && bundle.pair2Variant.featured_image.src
          ? bundle.pair2Variant.featured_image.src
          : bundle.pair2Variant.image;

      if (src2) img2.src = src2;
    }
  }

  function updateHiddenProperties(bundle) {
    if (pair1PropInput) pair1PropInput.value = bundle.pair1Text || '';
    if (pair2PropInput) pair2PropInput.value = bundle.pair2Text || '';

    if (variantIdInput && bundle.pair1Variant) {
      variantIdInput.value = bundle.pair1Variant.id;
    }
  }

function updateGallery(bundle) {
  if (
    window.__PDP_MEDIA_SLIDER__ &&
    typeof window.__PDP_MEDIA_SLIDER__.goToColor === 'function'
  ) {
    const activeColor = activeStep === 2
      ? (bundle.pair2Color || bundle.pair1Color)
      : (bundle.pair1Color || bundle.pair2Color);

    if (activeColor) {
      window.__PDP_MEDIA_SLIDER__.goToColor(activeColor);
    }
  }
}

  function updatePrice(bundle) {
    const qty = Math.max(1, parseInt(root.querySelector('#productQuantity')?.value, 10) || 1);

    if (bundle.pair1Variant && typeof window.updatePrice === 'function') {
      window.updatePrice(root, bundle.pair1Variant, bundle.pair1Variant.price * qty, qty);
    }
  }

  function updateBandMirror(bundle) {
    if (bandMirror) bandMirror.textContent = bundle.band || '';
  }

  function setStepUI(bundle) {
    const pair1CanContinue = canGoToPair2(bundle);

    if (activeStep === 2 && !pair1CanContinue) {
      activeStep = 1;
    }

    wizard.setAttribute('data-active-step', String(activeStep));

    if (stepLabel) {
      stepLabel.textContent = activeStep === 2 ? 'STEP 2 / 2' : 'STEP 1 / 2';
    }

    stepPanels.forEach((panel) => {
      const step = Number(panel.dataset.oldBogoPanel || 1);
      const open = step === activeStep;

      panel.hidden = !open;
      panel.classList.toggle('is-active', open);
    });

    stepCards.forEach((card) => {
      const step = Number(card.dataset.oldBogoCard || 1);
      const isCurrent = step === activeStep;

      card.classList.toggle('is-current', isCurrent);
      card.classList.toggle('is-active', step === 1 || hasVisitedStep2);
      card.classList.toggle('is-locked', step === 2 && !pair1CanContinue);
      card.classList.toggle('is-pending', step === 2 && pair1CanContinue && !hasVisitedStep2);
      card.classList.toggle('is-invalid', step === 2 && isPair2Invalid(bundle));
    });
  }

  function setAtcState(bundle) {
    const pair1Ok = isSellable(bundle.pair1Variant);
    const pair2Ok = isSellable(bundle.pair2Variant);
    const pair2Invalid = pair1Ok && isPair2Invalid(bundle);

    if (isSubmittingBundle) {
      atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'ADDING...';
      return;
    }

    if (!pair1Ok) {
      atcBtn.disabled = false;
      atcBtn.classList.add('is-notify');
      if (atcText) atcText.textContent = 'NOTIFY ME WHEN BACK IN STOCK';
      return;
    }

    atcBtn.classList.remove('is-notify');

    if (pair2Invalid) {
      atcBtn.disabled = false;

      if (activeStep === 2) {
        if (atcText) atcText.textContent = 'OUT OF STOCK';
      } else {
        if (atcText) atcText.textContent = 'CONTINUE TO PAIR 2';
      }

      return;
    }

    atcBtn.disabled = false;

    if (atcText) {
      atcText.innerHTML = '<i class="bi bi-cart-plus"></i> ADD TO BAG';
    }
  }

  function updateBundleState() {
    const bundle = getBundleSelections();

    markPair2InvalidOnLoad(bundle);

    updateSummary(bundle);
    updateHiddenProperties(bundle);
    updateGallery(bundle);
    updatePrice(bundle);
    updateBandMirror(bundle);
    setSelectedLabels();

    updateSizeAvailabilityForPair(1, paidVariants, bundle.pair1Color, bundle.band);
    updateSizeAvailabilityForPair(2, pair2Variants, bundle.pair2Color || bundle.pair1Color, bundle.band);

    setStepUI(bundle);
    setAtcState(bundle);

    return bundle;
  }

    function getTrackedMaxForVariant(variant) {
    if (!variant) return 0;

    const management = String(variant.inventory_management || '').trim();
    const policy = String(variant.inventory_policy || '').toLowerCase();
    const qty = Number(variant.inventory_quantity);

    if (!management) return Infinity;
    if (policy === 'continue') return Infinity;

    return Number.isFinite(qty) ? Math.max(0, qty) : 0;
  }

  function getBundleMaxQty(bundle) {
    if (!bundle || !bundle.pair1Variant) return 1;

    const pair1Max = getTrackedMaxForVariant(bundle.pair1Variant);

    if (!bundle.pair2Variant) {
      return pair1Max;
    }

    const pair2Max = getTrackedMaxForVariant(bundle.pair2Variant);

    if (
      !usingExternalFreePairProduct &&
      String(bundle.pair1Variant.id) === String(bundle.pair2Variant.id)
    ) {
      return pair1Max === Infinity ? Infinity : Math.floor(pair1Max / 2);
    }

    return Math.min(pair1Max, pair2Max);
  }

  function initBogoQuantityControls() {
    const qtyInput = root.querySelector('#productQuantity');
    const minusBtn = root.querySelector('.quantity-minus');
    const plusBtn = root.querySelector('.quantity-plus');
    const infoEl = root.querySelector('[data-qty-info]');

    if (!qtyInput || !minusBtn || !plusBtn) return;
    if (qtyInput.dataset.oldBogoQtyInitialized === 'true') return;

    qtyInput.dataset.oldBogoQtyInitialized = 'true';

    function showInfo(message) {
      if (!infoEl) return;

      infoEl.textContent = message || '';
      infoEl.hidden = !message;
    }

    function getQty() {
      return Math.max(1, parseInt(qtyInput.value, 10) || 1);
    }

    function setQty(nextQty) {
      qtyInput.value = String(Math.max(1, nextQty));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateBundleState();
    }

    minusBtn.addEventListener('click', function (event) {
      event.preventDefault();

      const currentQty = getQty();

      if (currentQty <= 1) {
        setQty(1);
        showInfo('');
        return;
      }

      setQty(currentQty - 1);
      showInfo('');
    });

    plusBtn.addEventListener('click', function (event) {
      event.preventDefault();

      const bundle = getBundleSelections();
      const currentQty = getQty();
      const maxQty = getBundleMaxQty(bundle);

      if (maxQty !== Infinity && currentQty >= maxQty) {
        showInfo(maxQty <= 1 ? 'Only 1 available.' : `Only ${maxQty} available.`);
        return;
      }

      setQty(currentQty + 1);
      showInfo('');
    });
  }

  function buildBundleItems(bundle) {
    const qty = Math.max(1, parseInt(root.querySelector('#productQuantity')?.value, 10) || 1);
    const groupId = 'bogo_' + Date.now() + '_' + Math.random().toString(36).slice(2);

    const paidProps = {
      'Pair 1': bundle.pair1Text,
      'Pair 2': bundle.pair2Text,
      '_bundle_type': 'free_pair',
      '_bundle_mode': 'custom_bogo_pairs',
      '_bundle_group': groupId,
      '_bundle_role': 'paid',
      '_pair_role': 'paid',
      '_pair_1_variant_id': String(bundle.pair1Variant.id),
      '_pair_2_variant_id': String(bundle.pair2Variant.id)
    };

    const freeProps = {
      'Pair 1': bundle.pair1Text,
      'Pair 2': bundle.pair2Text,
      '_bundle_type': 'free_pair',
      '_bundle_mode': 'custom_bogo_pairs',
      '_bundle_group': groupId,
      '_bundle_role': 'free',
      '_pair_role': 'free',
      '_pair_1_variant_id': String(bundle.pair1Variant.id),
      '_pair_2_variant_id': String(bundle.pair2Variant.id)
    };

    if (!usingExternalFreePairProduct && String(bundle.pair1Variant.id) === String(bundle.pair2Variant.id)) {
      return [
        {
          id: bundle.pair1Variant.id,
          quantity: qty * 2,
          properties: paidProps
        }
      ];
    }

    return [
      {
        id: bundle.pair2Variant.id,
        quantity: qty,
        properties: freeProps
      },
      {
        id: bundle.pair1Variant.id,
        quantity: qty,
        properties: paidProps
      }
    ];
  }

  function getCartAddUrl() {
    return window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';
  }

  function openCartDrawer(addResponse) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;

    try {
      if (addResponse && addResponse.sections && addResponse.sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(addResponse.sections['cart-drawer'], 'text/html');
        const newInner =
          html.querySelector('#CartDrawer .drawer__inner') ||
          html.querySelector('cart-drawer .drawer__inner') ||
          html.querySelector('.drawer__inner');

        const currentInner = drawer.querySelector('.drawer__inner');

        if (newInner && currentInner) {
          currentInner.replaceWith(newInner);
        }
      }

      if (addResponse && addResponse.sections && addResponse.sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(addResponse.sections['cart-icon-bubble'], 'text/html');
        const newBubble = html.getElementById('cart-icon-bubble');
        const currentBubble = document.getElementById('cart-icon-bubble');

        if (newBubble && currentBubble) {
          currentBubble.replaceWith(newBubble);
        }
      }

      drawer.classList.remove('is-empty');
      drawer.removeAttribute('is-empty');

      const inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');

      const checkout = drawer.querySelector('#CartDrawer-Checkout');
      if (checkout) checkout.disabled = false;

      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.classList.add('active');
        drawer.setAttribute('open', '');
      }

      return true;
    } catch (error) {
      console.error(error);
    }

    return false;
  }

  function addBundleToCart(bundle) {
    const items = buildBundleItems(bundle);

    isSubmittingBundle = true;
    atcBtn.disabled = true;

    if (atcText) atcText.textContent = 'ADDING...';
    if (spinner) spinner.classList.remove('hidden');

    return fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname + window.location.search
      })
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((err) => {
            throw err;
          });
        }

        return res.json();
      })
      .then((addResponse) => {
        openCartDrawer(addResponse);
      })
      .catch((err) => {
        console.error('BOGO add failed:', err);

        const message = root.querySelector('.product-form__error-message');
        const wrapper = root.querySelector('.product-form__error-message-wrapper');

        if (message) {
          message.textContent = err && err.description ? err.description : 'Could not add this bundle to cart.';
        }

        if (wrapper) {
          wrapper.hidden = false;
        }
      })
      .finally(() => {
        isSubmittingBundle = false;
        if (spinner) spinner.classList.add('hidden');
        updateBundleState();
      });
  }

  stepCards.forEach((card) => {
    card.addEventListener('click', () => {
      const step = Number(card.dataset.oldBogoCard || 1);
      const bundle = getBundleSelections();

      if (step === 2 && !canGoToPair2(bundle)) {
        activeStep = 1;
        updateBundleState();
        return;
      }

      activeStep = step === 2 ? 2 : 1;

      if (activeStep === 2) {
        hasVisitedStep2 = true;
      }

      updateBundleState();
    });
  });

  root.addEventListener('change', (event) => {
    const input = event.target;
    if (!input || !input.matches('.old-bogo-input')) return;

    const bundle = getBundleSelections();

    if (input.dataset.oldBogoPair === '1' && input.dataset.oldBogoKind !== 'band') {
      const pair1Ok = canGoToPair2(bundle);
      if (!pair1Ok) activeStep = 1;
    }

    if (input.dataset.oldBogoPair === '2') {
      hasVisitedStep2 = true;
    }

    window.requestAnimationFrame(updateBundleState);
  });

  atcBtn.addEventListener('click', (event) => {
    const bundle = getBundleSelections();
    const pair1Ok = isSellable(bundle.pair1Variant);
    const pair2Ok = isSellable(bundle.pair2Variant);
    const pair2Invalid = pair1Ok && isPair2Invalid(bundle);

    if (pair1Ok && pair2Ok) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!pair1Ok) {
      if (typeof window.sfTriggerKlaviyoBis === 'function') {
       window.sfTriggerKlaviyoBis(root);
      }
      return;
    }

    if (pair2Invalid || !pair2Ok) {
      activeStep = 2;
      hasVisitedStep2 = true;
      updateBundleState();
    }
  }, true);

  form.addEventListener('submit', (event) => {
    const bundle = updateBundleState();

    const pair1Ok = isSellable(bundle.pair1Variant);
    const pair2Ok = isSellable(bundle.pair2Variant);

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (!pair1Ok) {
      if (typeof window.sfTriggerKlaviyoBis === 'function') {
        window.sfTriggerKlaviyoBis(root);
      }
      return;
    }

    if (!pair2Ok) {
      activeStep = 2;
      hasVisitedStep2 = true;
      updateBundleState();
      return;
    }

    addBundleToCart(bundle);
  }, true);

  initBogoQuantityControls();
  updateBundleState();
}

 function initMediaSlider(root, config) {
  const viewport = root.querySelector('#mainMediaSlider');
  if (!viewport || viewport.dataset.sliderInitialized === 'true') return;

  viewport.dataset.sliderInitialized = 'true';

  const track = viewport.querySelector('.slider-track');
  if (!track) return;

  const allSlides = Array.from(track.querySelectorAll('.slider-slide'));
  const thumbWraps = Array.from(root.querySelectorAll('.thumbnail-wrapper [data-thumb-wrap]'));

  if (!allSlides.length) return;

  const VARIANT_MEDIA_BY_COLOR = config.variantMediaByColor || {};
  window.__PDP_VARIANT_MEDIA_BY_COLOR__ = VARIANT_MEDIA_BY_COLOR;

  let index = 0;
  let activeSlides = allSlides.slice();

  function mediaType(el) {
    return String(el?.dataset?.mediaType || '').toLowerCase();
  }

  function isVideo(el) {
    const type = mediaType(el);
    return type === 'video' || type === 'external_video';
  }

  function mediaColor(el) {
    return canon(el?.dataset?.color || '');
  }

  function mediaAlt(el) {
    return canon(el?.dataset?.mediaAlt || '');
  }

  function matchesColor(el, colorValue) {
    const color = canon(colorValue);
    if (!color) return false;

    const c = mediaColor(el);
    const alt = mediaAlt(el);

    if (c && c === color) return true;
    if (alt && alt.includes(color)) return true;

    return false;
  }

  function getThumbForSlide(slide) {
    const mediaId = slide?.dataset?.mediaId;
    if (!mediaId) return null;

    return thumbWraps.find((thumb) => {
      return String(thumb.dataset.mediaId) === String(mediaId);
    }) || null;
  }

  function visibleSlides() {
    return activeSlides.filter((slide) => !slide.hidden);
  }

  function sliderWidth() {
    return viewport.clientWidth || 1;
  }

  function handleMediaPlayback() {
    allSlides.forEach((slide) => {
      const vid = slide.querySelector('video');
      const iframe = slide.querySelector('iframe');
      const btn = slide.querySelector('.media-play-btn');

      if (!activeSlides[index] || slide !== activeSlides[index]) {
        if (vid) {
          try { vid.pause(); } catch (e) {}
        }

        if (iframe && iframe.src) iframe.src = '';
        if (btn) btn.classList.remove('hidden');
      } else {
        if (vid && btn) btn.classList.toggle('hidden', !vid.paused);
        if (iframe && btn) btn.classList.toggle('hidden', !!iframe.src);
      }
    });
  }

  function syncThumbIndexes() {
    activeSlides.forEach((slide, visibleIndex) => {
      const thumb = getThumbForSlide(slide);
      if (!thumb) return;

      const img = thumb.querySelector('img[data-media-id]');
      if (img) img.dataset.slideIndex = String(visibleIndex);
    });
  }

  function snap() {
    activeSlides = visibleSlides();

    if (!activeSlides.length) {
      activeSlides = allSlides.slice();
      activeSlides.forEach((slide) => {
        slide.hidden = false;
      });
    }

    index = Math.max(0, Math.min(index, activeSlides.length - 1));

    track.style.transform = `translateX(-${index * 100}%)`;

    const activeMediaId = activeSlides[index]?.dataset?.mediaId;

    thumbWraps.forEach((thumb) => {
      const isActive = String(thumb.dataset.mediaId) === String(activeMediaId);
      const img = thumb.querySelector('img');
      if (img) img.classList.toggle('active', isActive);
    });

    handleMediaPlayback();
  }

  function applyColorGallery(colorValue) {
    const color = canon(colorValue);
    const images = allSlides.filter((slide) => !isVideo(slide));
    const videos = allSlides.filter((slide) => isVideo(slide));

    let matchedImages = images.filter((slide) => matchesColor(slide, color));

    if (!matchedImages.length && color) {
      const mediaId =
        VARIANT_MEDIA_BY_COLOR[colorValue] ||
        VARIANT_MEDIA_BY_COLOR[String(colorValue || '').toLowerCase()] ||
        VARIANT_MEDIA_BY_COLOR[color];

      if (mediaId) {
        const byVariantMedia = images.find((slide) => {
          return String(slide.dataset.mediaId) === String(mediaId);
        });

        if (byVariantMedia) matchedImages = [byVariantMedia];
      }
    }

    if (!matchedImages.length) {
      matchedImages = images.slice(0, 1);
    }

    const ordered = [];

    if (matchedImages[0]) ordered.push(matchedImages[0]);

    if (videos[0]) ordered.push(videos[0]);

    matchedImages.slice(1).forEach((slide) => {
      ordered.push(slide);
    });

    videos.slice(1).forEach((slide) => {
      ordered.push(slide);
    });

    allSlides.forEach((slide) => {
      slide.hidden = true;
    });

    thumbWraps.forEach((thumb) => {
      thumb.hidden = true;
    });

    ordered.forEach((slide, visibleIndex) => {
      slide.hidden = false;
      slide.dataset.visibleIndex = String(visibleIndex);
      track.appendChild(slide);

      const thumb = getThumbForSlide(slide);
      if (thumb) {
        thumb.hidden = false;
        thumb.dataset.visibleIndex = String(visibleIndex);
        thumb.parentNode.appendChild(thumb);
      }
    });

    activeSlides = ordered;
    index = 0;
    syncThumbIndexes();
    snap();
  }

  let startX = 0;
  let deltaX = 0;
  let isDown = false;
  let pointerId = null;

  viewport.addEventListener('pointerdown', function (e) {
    isDown = true;
    pointerId = e.pointerId;
    viewport.setPointerCapture(pointerId);
    startX = e.clientX;
    deltaX = 0;
    track.style.transition = 'none';
  });

  viewport.addEventListener('pointermove', function (e) {
    if (!isDown) return;

    deltaX = e.clientX - startX;

    const deltaPct = (deltaX / sliderWidth()) * 100;
    track.style.transform = `translateX(calc(-${index} * 100% + ${deltaPct}%))`;
  });

  function onUp() {
    if (!isDown) return;

    isDown = false;
    track.style.transition = 'transform .3s ease';

    const maxIndex = activeSlides.length - 1;

    if (Math.abs(deltaX) > sliderWidth() * 0.15) {
      if (deltaX < 0 && index < maxIndex) index++;
      if (deltaX > 0 && index > 0) index--;
    }

    snap();
    deltaX = 0;
  }

  viewport.addEventListener('pointerup', onUp);
  viewport.addEventListener('pointercancel', onUp);
  viewport.addEventListener('pointerleave', onUp);

  allSlides.forEach((slide) => {
    const btn = slide.querySelector('.media-play-btn');
    if (!btn) return;

    btn.addEventListener('pointerdown', (e) => e.stopPropagation(), { passive: true });

    btn.addEventListener('click', (e) => {
      e.stopPropagation();

      const vid = slide.querySelector('video');
      const iframe = slide.querySelector('iframe');

      if (vid) {
        vid.muted = false;
        const p = vid.play();
        if (p && p.catch) p.catch(() => {});
        btn.classList.add('hidden');
      } else if (iframe) {
        if (!iframe.src && iframe.dataset.src) iframe.src = iframe.dataset.src;
        btn.classList.add('hidden');
      }
    });
  });

  root.querySelectorAll('.thumbnail-wrapper [data-thumb-wrap] img[data-media-id]').forEach((img) => {
    img.addEventListener('click', function (e) {
      e.preventDefault();

      const mediaId = img.dataset.mediaId;
      const targetIndex = activeSlides.findIndex((slide) => {
        return String(slide.dataset.mediaId) === String(mediaId);
      });

      if (targetIndex < 0) return;

      index = targetIndex;
      snap();
    });
  });

  window.changeMainImage = function (el, gotoIndex) {
    let next = -1;

    if (el && el.dataset && el.dataset.mediaId) {
      next = activeSlides.findIndex((slide) => {
        return String(slide.dataset.mediaId) === String(el.dataset.mediaId);
      });
    } else {
      next = Number(gotoIndex);
    }

    if (Number.isNaN(next) || next < 0) return;

    index = Math.max(0, Math.min(activeSlides.length - 1, next));
    snap();
  };

  window.__PDP_MEDIA_SLIDER__ = {
    goToIndex(i) {
      const next = Number(i);
      if (Number.isNaN(next)) return;

      index = Math.max(0, Math.min(activeSlides.length - 1, next));
      snap();
    },

    goToColor(colorName) {
      applyColorGallery(colorName);
    }
  };

  const firstColor =
    root.querySelector('[data-old-bogo-pair="1"][data-old-bogo-kind="color"]:checked')?.value ||
    root.querySelector('.variant-selector[data-option-index="' + config.indexes?.color + '"]:checked')?.value ||
    config.firstVisibleColorName ||
    '';

  applyColorGallery(firstColor);
}

  

  function initQuantity(root) {
    const qtyInput = root.querySelector('#productQuantity');
    const minusBtn = root.querySelector('.quantity-minus');
    const plusBtn = root.querySelector('.quantity-plus');
    const infoEl = root.querySelector('[data-qty-info]');

    if (!qtyInput || !minusBtn || !plusBtn) return;

    function getSelectedVariant() {
      return typeof window.findSelectedVariant === 'function' ? window.findSelectedVariant() : null;
    }

    function getTrackedMax(variant) {
      if (!variant) return Infinity;

      const management = String(variant.inventory_management || '').toLowerCase();
      const policy = String(variant.inventory_policy || '').toLowerCase();
      const qty = Number(variant.inventory_quantity);

      if (!management) return Infinity;
      if (policy === 'continue') return Infinity;

      return Number.isFinite(qty) ? Math.max(0, qty) : 0;
    }

    function showInfo(message) {
      if (!infoEl) return;

      infoEl.textContent = message || '';
      infoEl.hidden = !message;
    }

    function refreshPrice() {
      const variant = getSelectedVariant();
      if (!variant || typeof window.updatePrice !== 'function') return;

      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      window.updatePrice(root, variant, variant.price * qty, qty);
    }

    function syncToVariant(variant) {
      const currentQty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      const max = getTrackedMax(variant);

      if (max !== Infinity) {
        if (max <= 0) {
          qtyInput.value = '1';
          showInfo('Sold out.');
          refreshPrice();
          return;
        }

        if (currentQty > max) {
          qtyInput.value = String(max);
          showInfo(`Only ${max} available.`);
          refreshPrice();
          return;
        }
      }

      showInfo('');
      refreshPrice();
    }

    minusBtn.addEventListener('click', function () {
      const current = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = String(Math.max(1, current - 1));
      showInfo('');
      refreshPrice();
    });

    plusBtn.addEventListener('click', function () {
      const variant = getSelectedVariant();
      const current = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      const max = getTrackedMax(variant);

      if (max !== Infinity) {
        if (max <= 0) {
          showInfo('Sold out.');
          return;
        }

        if (current >= max) {
          showInfo(`Only ${max} available.`);
          return;
        }
      }

      qtyInput.value = String(current + 1);
      showInfo('');
      refreshPrice();
    });

    root.addEventListener('change', function (e) {
      if (e.target && e.target.matches('.variant-selector')) {
        syncToVariant(getSelectedVariant());
      }
    }, true);

    window.__PDP_QTY_SYNC_TO_VARIANT__ = syncToVariant;
    syncToVariant(getSelectedVariant());
  }

  function initAccordionEmbedVideos() {
    document.querySelectorAll('.js-embed-video').forEach(function (wrapper) {
      if (wrapper.dataset.embedInitialized === 'true') return;
      wrapper.dataset.embedInitialized = 'true';

      const btn = wrapper.querySelector('.acc-play-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        const provider = wrapper.dataset.provider;
        const id = wrapper.dataset.id;
        let src = '';

        if (provider === 'youtube') {
          src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1';
        } else if (provider === 'vimeo') {
          src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&playsinline=1';
        } else {
          return;
        }

        const ratio = document.createElement('div');
        ratio.className = 'ratio ratio-16x9';

        const iframe = document.createElement('iframe');
        iframe.className = 'w-100 h-100 rounded';
        iframe.setAttribute('allow', 'autoplay; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');
        iframe.src = src;

        ratio.appendChild(iframe);
        wrapper.innerHTML = '';
        wrapper.appendChild(ratio);
      });
    });
  }

  function initCustomAccordions(root) {
    const accordionRoots = root.querySelectorAll('[data-acc-root]');
    if (!accordionRoots.length) return;

    accordionRoots.forEach((accordionRoot) => {
      if (accordionRoot.dataset.accInitialized === 'true') return;
      accordionRoot.dataset.accInitialized = 'true';

      const buttons = accordionRoot.querySelectorAll('.accordion-button');

      function setItemState(button, open) {
        const targetSelector = button.getAttribute('data-bs-target');
        if (!targetSelector) return;

        const panel = accordionRoot.querySelector(targetSelector);
        if (!panel) return;

        button.classList.toggle('collapsed', !open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.classList.toggle('show', open);
        panel.style.height = open ? panel.scrollHeight + 'px' : '0px';
      }

      function closeSiblings(currentButton) {
        buttons.forEach((btn) => {
          if (btn !== currentButton) setItemState(btn, false);
        });
      }

      buttons.forEach((button) => {
        const targetSelector = button.getAttribute('data-bs-target');
        if (!targetSelector) return;

        const panel = accordionRoot.querySelector(targetSelector);
        if (!panel) return;

        const startsOpen = panel.classList.contains('show');

        panel.style.overflow = 'hidden';
        panel.style.transition = 'height .3s ease';
        panel.style.height = startsOpen ? panel.scrollHeight + 'px' : '0px';

        button.addEventListener('click', function (e) {
          e.preventDefault();

          const isOpen = panel.classList.contains('show');

          if (isOpen) {
            setItemState(button, false);
          } else {
            closeSiblings(button);
            setItemState(button, true);
          }
        });
      });

      window.addEventListener('resize', function () {
        buttons.forEach((button) => {
          const targetSelector = button.getAttribute('data-bs-target');
          if (!targetSelector) return;

          const panel = accordionRoot.querySelector(targetSelector);

          if (panel && panel.classList.contains('show')) {
            panel.style.height = panel.scrollHeight + 'px';
          }
        });
      });
    });
  }

  function initSelloutDropdowns(root) {
    root.querySelectorAll('.sellout').forEach(function (sellout) {
      if (sellout.dataset.selloutInitialized === 'true') return;
      sellout.dataset.selloutInitialized = 'true';

      const blockRoot = sellout.closest('[data-block]');
      const btn = sellout.querySelector('.sellout-row');
      const body = sellout.querySelector('.sellout-body');
      const inner = sellout.querySelector('.sellout-body-inner');

      if (!blockRoot || !btn || !body || !inner) return;

      function setOpen(open) {
        blockRoot.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.setAttribute('aria-hidden', open ? 'false' : 'true');
        body.style.height = open ? inner.scrollHeight + 'px' : '0px';
      }

      setOpen(blockRoot.dataset.defaultOpen === 'true');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(!blockRoot.classList.contains('is-open'));
      });

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(function () {
          if (blockRoot.classList.contains('is-open')) {
            body.style.height = inner.scrollHeight + 'px';
          }
        });

        ro.observe(inner);
      }

      window.addEventListener('resize', function () {
        if (blockRoot.classList.contains('is-open')) {
          body.style.height = inner.scrollHeight + 'px';
        }
      }, { passive: true });
    });
  }

  window.updatePrice = function (root, variant, totalPrice = null, quantity = 1) {
    const container = root?.querySelector('[data-price-container]');
    if (!container || !variant) return;

    const fmt = (amt) => {
      try {
        return new Intl.NumberFormat(window.ACTIVE_CURRENCY?.locale || 'en', {
          style: 'currency',
          currency: window.ACTIVE_CURRENCY?.code || 'EUR'
        }).format((amt || 0) / 100);
      } catch (e) {
        return (amt / 100).toFixed(2);
      }
    };

    const priceEl = container.querySelector('[data-price]');
    const compareEl = container.querySelector('[data-compare-price]');
    const pillEl = container.querySelector('[data-save-badge]');
    const bfMsg = container.querySelector('[data-bf-msg]');

    const BF_ENABLED = String(container.dataset.bfEnabled || 'true') === 'true';
    const BF_BEFORE = container.dataset.bfBefore || 'Save';
    const BF_EVENT = container.dataset.bfEvent || 'Black Friday!';
    const showCompare = container.dataset.showCompare === undefined
      ? true
      : String(container.dataset.showCompare) === 'true';
    const showPill = container.dataset.showPill === undefined
      ? true
      : String(container.dataset.showPill) === 'true';

    const unitPrice = variant.price || 0;
    const unitCompare = variant.compare_at_price || 0;
    const qty = Math.max(1, parseInt(quantity) || 1);

    const finalPrice = totalPrice != null ? totalPrice : unitPrice * qty;
    const finalCompare = unitCompare ? unitCompare * qty : 0;
    const saving = Math.max(0, finalCompare - finalPrice);

    if (priceEl) priceEl.textContent = fmt(finalPrice);

    if (finalCompare > finalPrice) {
      if (compareEl) {
        if (showCompare) {
          compareEl.textContent = fmt(finalCompare);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      const pct = Math.round((saving / finalCompare) * 100);

      if (pillEl) {
        if (showPill && isFinite(pct) && pct > 0) {
          pillEl.textContent = `${pct}% OFF`;
          pillEl.style.display = '';
        } else {
          pillEl.textContent = '';
          pillEl.style.display = 'none';
        }
      }

      if (bfMsg) {
        if (BF_ENABLED) {
          bfMsg.innerHTML = `${BF_BEFORE} ${fmt(saving)} this <b>${BF_EVENT}</b>`;
          bfMsg.style.display = '';
        } else {
          bfMsg.textContent = '';
          bfMsg.style.display = 'none';
        }
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';

      if (pillEl) {
        pillEl.textContent = '';
        pillEl.style.display = 'none';
      }

      if (bfMsg) {
        bfMsg.textContent = '';
        bfMsg.style.display = 'none';
      }
    }
  };

  function initCountdowns() {
    const pad = (n) => String(n).padStart(2, '0');

    function tick() {
      document.querySelectorAll('[data-countdown]').forEach((node) => {
        const endISO = node.getAttribute('data-end');
        if (!endISO) return;

        const end = new Date(endISO.replace(' ', 'T'));
        const now = new Date();

        let diff = Math.max(0, end - now);

        const d = Math.floor(diff / 86400000);
        diff -= d * 86400000;

        const h = Math.floor(diff / 3600000);
        diff -= h * 3600000;

        const m = Math.floor(diff / 60000);

        node.textContent = `${pad(d)} days : ${pad(h)} hours : ${pad(m)} min`;
      });
    }

    tick();
    setInterval(tick, 60000);
  }

  function initAppliedDiscountNote(root, config) {
    if (config.templateSuffix !== '2xrbl-buy-1-get-1-free') return;

    const note = root.querySelector('[data-applied-discount-note]');
    if (!note) return;

    function getParam(name) {
      try {
        return new URL(window.location.href).searchParams.get(name);
      } catch (e) {
        return null;
      }
    }

    const discountActive = getParam('discount_active');

    if (discountActive === '1') {
      note.style.display = 'inline';

      try {
        sessionStorage.setItem('pdp_discount_active', '1');
      } catch (e) {}

      return;
    }

    try {
      if (sessionStorage.getItem('pdp_discount_active') === '1') {
        note.style.display = 'inline';
      }
    } catch (e) {}
  }
})();